'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sequenceOf = {};

exports.__exports = sequenceOf;
